import React, { useState } from "react";
import {
  FiChevronDown,
  FiLogOut,
  FiMenu,
  FiSettings,
  FiUser,
} from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { openModal } from "../store/uiSlice";
import { selectAdminProfile } from "../store/authSlice";
import styles from "./AdminHeader.module.css";

export default function AdminHeader({ onMenuClick }) {
  const profile = useSelector(selectAdminProfile);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <button
          type="button"
          className={styles.menuButton}
          onClick={onMenuClick}
          aria-label="Open menu"
        >
          <FiMenu />
        </button>
        <div className={styles.content}>
          <h1 className={styles.title}>Admin Dashboard</h1>
          <p className={styles.subtitle}>
            Manage users, profile, and portal access.
          </p>
        </div>
      </div>
      <div className={styles.profile}>
        <button
          type="button"
          className={styles.trigger}
          onClick={() => setOpen((v) => !v)}
        >
          <div className={styles.avatar}>
            <FiUser />
          </div>
          <div className={styles.meta}>
            <strong>{profile.name}</strong>
            <span>{profile.role}</span>
          </div>
          <FiChevronDown />
        </button>
        {open ? (
          <div className={styles.dropdown}>
            <button
              type="button"
              onClick={() => {
                setOpen(false);
                navigate("/admin/profile-settings");
              }}
            >
              <FiSettings />
              <span>Profile Setting</span>
            </button>
            <button
              type="button"
              onClick={() => {
                setOpen(false);
                dispatch(
                  openModal({
                    name: "confirmLogout",
                    props: {
                      title: "Logout from admin?",
                      message: "You will need to sign in again to continue.",
                    },
                  }),
                );
              }}
            >
              <FiLogOut />
              <span>Logout</span>
            </button>
          </div>
        ) : null}
      </div>
    </header>
  );
}
